export default __webpack_public_path__ + "static/media/palloncinoTtsIt_It60.c73a2eb7.mp3";